import axios from "axios";
import { environment } from "../../environment";

export const ActivityService = () => {

  const get = async () => {
    try {
      const res = await axios.get(environment.contentUrl + "user-activity");
      if (res && res.data) {
        return res.data;
      } else {
        throw new Error("No data");
      }
    } catch (err) {
      throw err;
    }
  };

  return {
    get,
  };
};
